<template>
  <div id="Counter">
    <button id="sub" class="counterButton" :disabled="points <= calledPoints +1" v-on:click="sub()"> - </button>
    <input type="number" class="counterText" name="pointCounter" :value="points" @input="validate"/>
    <button id="add" class="counterButton" :disabled="points >= 120" v-on:click="add()"> + </button>
    <button id="call" class="counterButton callButton" v-on:click="callPoints()" :disabled="!callEnabled || points <= calledPoints"> Chiama </button>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "Counter",
  data() {
    return {
      subEnabled: false,
      addEnabled: true,
    }
  },
  computed: {
    ...mapGetters({ 
      calledPoints: "call/calledPoints",
      callEnabled: "game/isMyTurn"
    }),
    ...mapState({
      points: (state) => state.call.points,
    })
  },
  methods: {
    sub() {
      this.$store.commit("call/updatePoints", (this.points - 2))
    },
    add() {
      this.$store.commit("call/updatePoints", (parseInt(this.points) + 2))
    },
    callPoints() {
      let payload = {
        card: '2',
        points: this.points
      }
      this.$store.dispatch("call/callCard", payload);
    },
    validate(e) {
      if(parseInt(e.target.value) > 120) {
        this.$store.commit("call/updatePoints", 120)
      } else {
        this.$store.commit("call/updatePoints", parseInt(e.target.value))
      }
    }
  }
};
</script>
<style scoped>
.counterText {
    font-size: 16px;
    padding: 5px 5px;
    width: 50px;
    text-align: center;
}
.counterButton {
  background-color: black;
  border: solid 2px white;
  color: white;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 20px;
  font-weight: 800;
  margin: 5px;
}
.counterButton:hover:enabled {
  background-color: white;
  border: solid 2px black;
  color: black;
}
.counterButton:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.callButton {
  font-size: 14px;
  padding: 5px 10px;
}
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
